import React, { useState } from "react";

import { makeStyles } from "@mui/styles";

import CircularProgress from "@mui/material/CircularProgress";

import LinearProgress from "@mui/material/LinearProgress";


import FormControl from "@mui/material/FormControl";


import {
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Divider,
  Button,
  Grid,
  TextField,
  InputLabel,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";



import clsx from "clsx";
import { useQuery, useMutation } from "@tanstack/react-query";

import { useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
} from "store/actions/snackbarMessage";
import { queryRestaurantUsers } from "apis/userAPIs";

import { createDisplayClient, getAllPosClients } from "apis/devicesAPIs";




const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
  root: {},
  details: {
    display: "flex",
  },
  avatar: {
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
  },
  locationText: {
    paddingLeft: "15px",
  },
  buttonProperty: {
    position: "absolute",
    top: "50%",
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  progess: {
    position: "absolute",
  },
  uploadButton: {
    marginLeft: "8px",
    margin: theme.spacing(1),
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },
  submitButton: {
    marginTop: "10px",
  },
}));



const DisplayClient = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();


  const [clientName, setClientName] = useState("");
  const [posClients, setPosClients] = useState([]);
  const [usernameInput, setUsernameInput] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userId, setUserId] = useState(null);


  const updateUserNameAndEmail = (user) => {
    
    if (user) {
      setUsernameInput(user);
      setUserEmail(user.email);
      setUserId(user.userId);
    }
  };


  const [buttonLoading, setButtonLoading] = useState(false);

  const history = useHistory();

  const showError = (msg) => dispatch(showErrorSnackbar(msg));
  const showSuccessMessage = (msg) => dispatch(showSuccessSnackbar(msg));

  
  // create createPOSClient mutation with clientName, clientType, username, printerZones use react-query
   const { mutate: createDisplayClientMutation, isLoading: isCreateLoading } = useMutation({
    mutationFn: createDisplayClient,
      onSuccess: (data) => {
        console.log("createDisplayClientMutation success", data);
        showSuccessMessage("Display Client created successfully");
        history.push("/displayClients");
      },
      onError: (error) => {
        console.log("createDisplayClientMutation error", error);
        showError("Something went wrong");
        setButtonLoading(false);
      },
    }
  );


  const { data: allPosClients, isLoading: isPosClientLoading } = useQuery({
    queryKey: ["posClients"],
    queryFn: getAllPosClients
  });

  const { data: allUsers, isLoading: isUserLoading } = useQuery({
    queryKey: ["allUsers"],
    queryFn: queryRestaurantUsers
  });

  const saveDisplayClient = (event) => {
    event.preventDefault();

    const payload = {
      displayClientName: clientName,
      username: usernameInput.username,
      userEmail,
      posIds: posClients.map((posClient) => posClient.id),
      posClientNames: posClients.map((posClient) => posClient.posClientName),
      userId: userId
    };

   
    setButtonLoading(true);
    createDisplayClientMutation(payload);
  };

  const handlePosClientChange = (event) => {
    // console.log(event.target.value);
    const selectedPosClients = [];
    event.target.value.forEach((pz) => {
      const posClient = allPosClients.find((p) => p.id === pz);
      if (posClient) {
        selectedPosClients.push(posClient);
      }
    });

    // console.log("selectedPrinterZones", selectedPrinterZones);
    setPosClients(selectedPosClients);
  };



  return (
    <main className={classes.content}>
      {buttonLoading || isUserLoading || isPosClientLoading ? <LinearProgress /> : null}
      <Card className={clsx(classes.root, classes)}>
        <CardHeader title="Display Client" subheader="Create Display Client" />
        <form autoComplete="off" noValidate>
          <CardContent>
            <Grid container spacing={3} direction="column">
            <Grid item xs={12}>
              <TextField
                id="client-name"
                label="Client Name"
                variant="outlined"
                fullWidth
                required
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
            <InputLabel id="printer-zone-label" style = {{marginBottom: 4}}>Login Username</InputLabel>
            <Select
                  value={usernameInput}
                  onChange={(e) => updateUserNameAndEmail(e.target.value)}
                >
                  {allUsers && allUsers.map((user) => (
                    <MenuItem key={user.username} value={user}>
                      {user.username} - {user.email}
                    </MenuItem>
                  ))}
                </Select>
            </Grid>
            <Grid item xs={12}>
            <InputLabel id="pos-client-label" style = {{marginBottom: 4}}>POS Client</InputLabel>
              <FormControl variant="outlined" fullWidth>
              
                <Select
                  multiple
                  value={
                    posClients ? posClients.map((posClient) => posClient.id) : []
                  }
                  onChange={handlePosClientChange}
                  label="POS Client"
                >
                  {allPosClients && allPosClients.map((posClient) => (
                    <MenuItem key={posClient} value={posClient.id}>
                      {posClient.posClientName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions />
        </form>
      </Card>

      <Button
        color="primary"
        variant="contained"
        type="submit"
        className={classes.submitButton}
        onClick={saveDisplayClient}
        disabled={
          buttonLoading || !clientName || !usernameInput || !posClients.length
        }
      >
        Save Client
        {buttonLoading && (
          <CircularProgress size={30} className={classes.progess} />
        )}
      </Button>
    </main>
  );
};

export default DisplayClient;
